import Config from '../domain/entities/Config';

export default class ConfigUtils {
  /**
   * get JSON from data-config attached to the root element
   */
  static getFromDataConfigAttr(): Config {
    const rootElem = document.getElementById('root');
    const dataConfig = rootElem.getAttribute('data-config');

    return JSON.parse(dataConfig);
  }
}
